import {
  Component,
  OnInit,
  AfterViewChecked,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  forwardRef,
  Provider,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { UtilService } from '../../shared/util/util.service';
import { DialogService } from '../../shared/dialog/dialog.service';
import { TranslationService } from '../../shared/translation/translation.service';
import { CreditCardInputComponent } from '../credit-card-input/credit-card-input.component';
import { CreditCardGatewayService } from '../shared/credit-card-gateway/credit-card-gateway.service';
import { CreditCardPaymentInfo } from '../shared/credit-card/credit-card-payment-info.model';
import { CreditCardService } from '../shared/credit-card/credit-card.service';

import { CreditCardPaymentResult } from '../shared/credit-card/credit-card-payment-result.model';
import { CreditCardGateway } from '../shared/credit-card-gateway/credit-card-gateway.model';

import { InvoiceLookupComponent } from '../invoice-lookup/invoice-lookup.component';
import { Invoice } from '../shared/invoice/invoice.model';
import { InvoiceLineItem } from '../shared/invoice/invoice-lineitem.model';

import { InvoicePaymentService } from '../shared/invoice-payment/invoice-payment.service';
import { InvoicePayment } from '../shared/invoice-payment/invoice-payment.model';

import { PaymentTypeService } from '../shared/payment-types/payment-type.service';
import { PaymentType } from '../shared/payment-types/payment-type.model';

import { AccountingPackageService } from '../shared/accounting-package/accounting-package.service';
import { AccountingPackage } from '../shared/accounting-package/accounting-package.model';
import { AccountingPackageRevenueItem } from '../shared/accounting-package/accounting-package-revenue-item.model';
import { AccountingPackagePaymentType } from '../shared/accounting-package/accounting-package-payment-type.model';
import { AccountingPackageAdjustmentType } from '../shared/accounting-package/accounting-package-adjustment-type.model';
import { AccountingPackageMatchOptions } from '../shared/accounting-package/accounting-package-match-options.model';
import { PrecznService } from '../../integrations/preczn/shared/preczn.service';
import { TokenizeGatewayDto } from '../shared/gateway-resolution/dto/tokenize-gateway.dto';

@Component({
  selector: 'wl-credit-card-charge',
  templateUrl: 'credit-card-charge.component.html',
  providers: [CreditCardService, CreditCardGatewayService, InvoicePaymentService, PaymentTypeService],
    standalone: false
})
export class CreditCardChargeComponent implements OnInit {
  @ViewChild('creditCardInput', { static: false }) creditCardInputComponent: CreditCardInputComponent;
  @ViewChild('invoiceLookup', { static: false }) invoiceLookupComponent: InvoiceLookupComponent;

  public _translationService: TranslationService;
  public _utilService: UtilService;
  public _dialogService: DialogService;
  public _creditcardService: CreditCardService;
  public _creditCardGatewayService: CreditCardGatewayService;
  public _invoicePaymentService: InvoicePaymentService;
  public _paymentTypeService: PaymentTypeService;
  public _accountingPackageService: AccountingPackageService;

  public isProcessing: boolean;
  public creditCardPayment: CreditCardPaymentInfo;
  public result: string;

  public cardGateways: Array<CreditCardGateway>;
  public selectedGatewayId: number;
  public amountToCharge: number;
  public maxAmountToCharge: number;
  public invoiceNumber: number;
  public selectedPaymentTypeId: number;
  public paymentTypes: Array<AccountingPackagePaymentType>;
  public message: string;
  // Direct-gateway surface: selectedGatewayId is the paying gateway already carried by the chosen
  // payment type, so no revenue-item resolution round trip is made here.
  public resolvedGateway: TokenizeGatewayDto | null = null;

  public constructor(
    translationService: TranslationService,
    utilService: UtilService,
    creditcardService: CreditCardService,
    creditCardGatewayService: CreditCardGatewayService,
    invoicePaymentService: InvoicePaymentService,
    paymentTypeService: PaymentTypeService,
    accountingPackageService: AccountingPackageService,
    dialogService: DialogService,
    private _precznService: PrecznService
  ) {
    this._translationService = translationService;
    this._utilService = utilService;
    this._dialogService = dialogService;
    this._creditcardService = creditcardService;
    this._creditCardGatewayService = creditCardGatewayService;
    this._invoicePaymentService = invoicePaymentService;
    this._paymentTypeService = paymentTypeService;
    this._accountingPackageService = accountingPackageService;

    this.isProcessing = false;
    this.creditCardPayment = new CreditCardPaymentInfo();
    this.result = '';
    this.cardGateways = new Array<CreditCardGateway>();
    this.selectedGatewayId = 0;
    this.amountToCharge = 0;
    this.invoiceNumber = 0;
    this.maxAmountToCharge = 0;

    this.selectedPaymentTypeId = 0;
  }
  ngOnInit(): void {
    this.invoiceLookupComponent.invoiceSearchParams.OpenInvoicesOnly = true;
    this.invoiceLookupComponent.searchOnOpen = true;

    this._creditCardGatewayService.getCreditCardGateways().then((data: Array<CreditCardGateway>) => {
      this.cardGateways = data;
      if (data.length > 0) {
        this.selectedGatewayId = data[0].CCGatewayID;
      }
    });

    //this._paymentTypeService.getCreditCardPaymentTypes().then((data: Array<PaymentType>) => {

    //    this.paymentTypes = data;
    //    if (data.length > 0) {
    //        this.selectedPaymentTypeId = data[0].PaymentTypeId;
    //    }

    //});
  }

  public processCard = async (): Promise<void> => {
    if (this.creditCardInputComponent?.usePreczn) {
      try {
        await this.creditCardInputComponent.prepareForSubmit();
      } catch (e) {
        this._dialogService.error(e);
        return;
      }
    }
    this.isProcessing = true;

    this.creditCardPayment = this.creditCardInputComponent.getCreditCardPaymentInfo();
    this.creditCardPayment.Amount = this.amountToCharge;
    this.creditCardPayment.InvoiceNumber = this.invoiceNumber;
    this.creditCardPayment.CCGatewayID = this.selectedGatewayId;

    this._creditcardService.processCreditCardPayment(this.creditCardPayment).then(
      (data: CreditCardPaymentResult) => {
        if (data.Succeeded) {
          this.result = this._translationService.getInstantTitlecase('common.success') + ' ' + data.CcId + ' ' + data.RawTransactionResult;

          //generate payment records
          var paymentDetails = new InvoicePayment();
          paymentDetails.Amount = this.amountToCharge;
          paymentDetails.ApplyDate = new Date();
          paymentDetails.CC_CreditCardNum = data.CcId;
          paymentDetails.CC_NameOnCard = this.creditCardPayment.CreditCardContactInfo.NameOnCard;
          paymentDetails.CC_BillingAddress1 = this.creditCardPayment.CreditCardContactInfo.Address1;
          paymentDetails.CC_BillingAddress2 = this.creditCardPayment.CreditCardContactInfo.Address2;
          paymentDetails.CC_BillingCity = this.creditCardPayment.CreditCardContactInfo.City;
          paymentDetails.CC_BillingState = this.creditCardPayment.CreditCardContactInfo.State;
          paymentDetails.CC_BillingZip = this.creditCardPayment.CreditCardContactInfo.Zip;
          paymentDetails.CC_PhoneNum = this.creditCardPayment.CreditCardContactInfo.Phone;
          paymentDetails.CC_ValidThrough =
            this.creditCardPayment.ValidThruMonth.toString() + this.creditCardPayment.ValidThruMonth.toString();
          paymentDetails.PaymentTypeID = this.selectedPaymentTypeId;

          this._invoicePaymentService.createInvoicePaymentRecordsForOpenInvoice(this.invoiceNumber, paymentDetails);
          this._dialogService.info(this.result);
          this.clearForm();
        } else {
          this.result = this._translationService.getInstantTitlecase('common.error') + ' ' + data.CcId + ' ' + data.RawTransactionResult;
          this._dialogService.error(this.result);
        }
        this.isProcessing = false;
      },
      () => {
        this.isProcessing = false;
      }
    );
  };

  public clearForm = (): void => {
    this.amountToCharge = 0;
    this.invoiceNumber = 0;
    this.creditCardInputComponent.clearForm();
    this.invoiceLookupComponent.clearForm();
  };

  public onGatewayChange = (data: any): void => {
    //this.creditCardInputComponent.useCardConnect = false;
    //this.selectedGatewayId = parseInt(data);
    ////see if its use card connect
    //for (let gateway of this.cardGateways) {
    //    if (this.selectedGatewayId == gateway.CCGatewayID) {
    //        if (gateway.GatewayTypeID == 6) {
    //            this.creditCardInputComponent.useCardConnect = true;
    //        }
    //    }
    //}
  };

  public onPaymentTypeChange = (data: any): void => {
    this.selectedPaymentTypeId = parseInt(data);

    this.updateSelectedCreditCardGateway();
    this.updateCreditCardInput();
  };

  public onInvoiceChanged = ($event: Invoice): void => {
    var invoiceNum = $event.InvoiceNum;
    this.amountToCharge = $event.AdjustedAmountDue;
    this.maxAmountToCharge = $event.AdjustedAmountDue;
    this.message = '';

    this._accountingPackageService.getPaymentTypesAvailableForInvoice(invoiceNum).then((data: Array<AccountingPackagePaymentType>) => {
      this.paymentTypes = data.filter((data: AccountingPackagePaymentType) => {
        return data.CreditCardType == true;
      });

      if (this.paymentTypes.length > 0) {
        this.selectedPaymentTypeId = this.paymentTypes[0].PaymentTypeId;
        //this.selectedGatewayId = this.paymentTypes[0].CcGatewayId;

        this.updateSelectedCreditCardGateway();
        this.updateCreditCardInput();
      } else {
        this.selectedPaymentTypeId = 0;
        this.selectedGatewayId = 0;
        this.message = this._translationService.getInstant('revenue.credit-card-charge.no-payment-types-found-error');
      }
    });
  };
  public updateSelectedCreditCardGateway = (): void => {
    for (let paymentType of this.paymentTypes) {
      if (this.selectedPaymentTypeId == paymentType.PaymentTypeId) {
        this.selectedGatewayId = paymentType.CcGatewayId;
      }
    }
    this.updateResolvedGateway();
  };

  // The widget here is mounted unconditionally, so it loads the SDK before any payment type has
  // been picked; this is what retargets it once the gateway is known (and on every later change).
  private updateResolvedGateway = (): void => {
    this._precznService.resolveTokenizeGateway(this.selectedGatewayId).then((gateway) => {
      this.resolvedGateway = gateway;
    });
  };
  public updateCreditCardInput = (): void => {
    //see if its use card connect
    for (let gateway of this.cardGateways) {
      if (this.selectedGatewayId == gateway.CCGatewayID) {
        if (gateway.GatewayTypeID == 6) {
          this.creditCardInputComponent.useCardConnect = true;
        } else {
          this.creditCardInputComponent.useCardConnect = false;
        }
      }
    }
  };
  public isValid = (): boolean => {
    var isValid = true;
    this.creditCardPayment = this.creditCardInputComponent.getCreditCardPaymentInfo();

    if (
      this.amountToCharge <= 0 ||
      this.creditCardInputComponent.isValid() == false ||
      this.isProcessing == true ||
      this.invoiceNumber <= 0 ||
      this.amountToCharge > this.maxAmountToCharge ||
      this.selectedGatewayId <= 0 ||
      this.selectedPaymentTypeId <= 0 ||
      this._utilService.isNullEmptyOrWhitespace(this.creditCardPayment.CreditCardContactInfo.NameOnCard) ||
      this._utilService.isNullEmptyOrWhitespace(this.creditCardPayment.CardNum) ||
      this._utilService.isNullOrLessThanOrEqualToZero(this.creditCardPayment.ValidThruMonth) ||
      this._utilService.isNullOrLessThanOrEqualToZero(this.creditCardPayment.ValidThruYear)
    ) {
      isValid = false;
    }

    return isValid;
  };
}
